<template>
	<div>
		<div :style="styleObj"  style="display: flex;align-items: center;background-color: #f4f4f6 ;justify-content: space-around;">
			<input :style="{width:iptWidth + 'px'}" :disabled="disabled" class="inp" @input="input" v-model="iptValue" style="border: 0px;width: 20px;background-color: #f4f4f6 ;height: 22px;border: solid 0px #f4f4f6;font-size: 14px;padding: 0px;text-indent:0px"
				 />
			<div v-if="isIcon" style="display: flex;flex-direction: column;;height: 38px;justify-content: center;">
				<i @click="change('add')" class="el-icon-caret-top caret"></i>
				<i @click="change('sub')" class="el-icon-caret-bottom caret"></i>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			isIcon:{
				type:Boolean,
				default: false
			},
			iptWidth:{
				type:Number,
				default: 40
			},
			disabled:{
				type:Boolean,
				default: true
			},
			step:{
				type:Number,
				default: 1
			},
			min:{
				type:Number,
				default: 1
			},
			max:{
				type:Number,
				default: 1
			},
			value: {
				default: 1
			},
			styleObj: {
				type: Object,
				default: () => {
					return {
						width: "120px",
						height: "34px"
					}
				}
			}
		},
		data() {
			return {
				iptValue:0
			}
		},
		watch:{
			value:{
				handler: function(newVal, oldVal) {
					console.log('newVal',newVal)
					this.iptValue = newVal
				}
			}
		},
		mounted() {
			 this.iptValue = this.value
		},
		methods:{
			input(e) {
				console.log('int',this.iptValue)
				let num = parseInt(this.iptValue)
				if(!num) {
					num = 0
				}
				if(num > this.max) {
					num = this.max
				}
				// if(num < this.min) {
				// 	num = this.min
				// }
				this.iptValue = num
				this.$emit('change',num)
			},
			change(type) {
				if(type == 'add'){
					if((this.value + this.step) <= this.max) {
						this.$emit('change',this.value + this.step)
					}
				}else { 
					console.log('this.value - this.step',this.value - this.step)
					console.log('this.min',this.min)
					if((this.value - this.step) > this.min) {
						this.$emit('change',this.value - this.step)
					}else {
						this.$emit('change',this.min)
					}
				}
			},
			add() {
				this.$emit('add')
			},
			sub() {
				this.$emit('sub')
			}
		}
	}
</script>

<style scoped>
	#input {  
	  padding: 100px;  
	}  
	 .inp:focus {
	        /* background-color: red; */
	        border-radius: 0px;
	        border: 0;
	        outline: 0px solid aqua;
	    }
	/* 
	::v-deep .el-input:hover{
		border: solid 0px;
	}
	::v-deep .is-disabled:hover{
		border: solid 0px;
	}
	
	::v-deep .el-input__inner:hover {
		border: solid 0px;
	} */
	::v-deep .el-input__inner {
		cursor: default;
		color: black;
		/* transition:none */
	}

	::v-deep .el-input {
		color: black;
		cursor: default;
		/* transition:none */
	}

	::v-deep .is-disabled {
		color: black;
		cursor: default;
		border: solid 0px;
		/* transition:none */
	}

	.caret {
		cursor: pointer;
		color: "#55aaff";
		font-size: 14px;
	}

	.caret:hover {
		color: #55aaff;
	}
</style>